import { requestAndParse, requestSuccessful } from '../request';

const removeQuestionFromStudy = async (studyId: number, questionId: number) => {
    const route = 'admin/remove-question-from-study';
    const payload = { studyId, questionId };

    const response = await requestAndParse(route, payload, 'POST');

    const success = requestSuccessful(response);

    return success;
};

export default removeQuestionFromStudy;
